import { render, staticRenderFns } from "./netwerkdiensten.vue?vue&type=template&id=3250731f&scoped=true"
import script from "./netwerkdiensten.vue?vue&type=script&lang=js"
export * from "./netwerkdiensten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3250731f",
  null
  
)

export default component.exports